<!-- 左中 -->
<template>
    <div class='bg box_v'>
        <div class="title">月访问新增用户情况</div>
        <div class='box_f1' id="echart2" style="width:100%;height:100%"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
import { type } from 'os';
import { parse } from 'path';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            accessCount:[],
            accessTag:'',
            realNameUserCount:[],
            realNameTag:'',
            maxNumber:[],
            mon:[],
            accessMax:0,
            realNameMax:0
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.newUser).then(res=>{
                
                this.mon = res.rows.map(item=>item.mon)

                /**访问数 */
                let accessCount = res.rows.map(item=>item.accessCount)
                let returnData = this.$util.handleNumber(accessCount)
                this.accessCount = returnData.numArr
                this.accessTag = returnData.tag

                /**实名认证 */
                let realNameUserCount = res.rows.map(item=>item.realNameUserCount)
                returnData = this.$util.handleNumber(realNameUserCount)
                this.realNameUserCount = returnData.numArr
                this.realNameTag = returnData.tag
                
                //这是一个奇怪的逻辑，用来设置柱状图背景的数为整数
                this.realNameUserCount.forEach(item=>{
                    if(parseFloat(item)>this.realNameMax) this.realNameMax = parseInt(item)
                })
                let realNameMaxArr = this.realNameMax.toString().split('')
                realNameMaxArr[0] = parseInt(realNameMaxArr[0])+1
                realNameMaxArr = realNameMaxArr.map((item,index)=>{
                    return index?0:item
                    
                })
                let realNameMax = parseInt(realNameMaxArr.join(''))
                this.maxNumber = new Array(12).fill(realNameMax)
                //这是一个奇怪的逻辑，结束

                this.$nextTick(()=>{
                    this.initEcharts()
                })
            }).catch(e=>console.log(e))
        },
        initEcharts(){
            let echart2 = echarts.init(document.getElementById('echart2'));

            let option = {
                xAxis: {
                    type: 'category',
                    data:this.mon,
                    
                    axisLabel: {
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    axisLine:{show: false}
                },
                yAxis: [{
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: '#6BD3FF'
                        },
                        formatter: '{value}' + this.accessTag,
                    },
                    min: 0,
                    max: this.maxNumber[0],
                    splitLine:{show: false},//去除网格线
                    axisLine:{show: false}
                },{
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: '#FFA800'
                        },
                        formatter: '{value}'+ this.realNameTag,
                    },
                    // min: 0,
                    // max: parseInt(this.accessMax*1.2),
                    splitLine:{show: false},//去除网格线
                    axisLine:{show: false}
                }],
                legend: {
                    data: ['新增实名认证用户量','访问量'],
                    right:'20',
                    textStyle:{
                        color:'#fff'
                    }
                },
                series: [{ // For shadow
                    type: 'bar',
                    itemStyle: {
                        color: 'rgba(127, 127, 127, 0)',
                        borderColor:'#008cff',
                        barBorderRadius:6,
                        barWidth:'10',
                    },
                    barGap: '-100%',
                    barCategoryGap: '15px',
                    barWidth:'10',
                    data: this.maxNumber,
                    animation: false
                },{
                    name:'新增实名认证用户量',
                    data: this.realNameUserCount,
                    type: 'bar',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#0491F3'},
                                {offset: 1, color: '#4020AB'}
                            ]
                        ),
                        barBorderRadius:6,
                        barWidth:'10',
                    },
                    barWidth:'10',
                    barCategoryGap: '15px',
                    // showBackground: true,
                    // backgroundStyle: {
                    //     color: 'rgba(127, 127, 127, 0.5)',
                    //     borderColor:'#fff',
                    //     barBorderRadius:'6px'
                    // }
                },{
                    name:'访问量',
                    data: this.accessCount,
                    type: 'line',
                    color:['#FFA800'],
                    symbol:'circle',
                    symbolSize:6,
                    lineStyle:{
                        color:'#FFA800'
                    },
                    yAxisIndex: 1,
                    itemStyle:{
                        normal:{
                            color:'#FFA800',
                            borderColor:'#FFA800',
                        }

                    }
                }],
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b1}<br />{a1}: {c1}'+this.accessTag+'<br />{a2}: {c2}'+this.realNameTag,
                    axisPointer: {
                        type: 'line',
                    },
                    
                },

            };
            

            echart2.setOption(option)
            
            echart2.on('legendselectchanged', (params)=>{
                console.log(params)
                let formatter = ''
                let key = ''
                let falseNumber = 0
                for(key in params.selected){
                    if(!params.selected[key]) falseNumber++
                }
                if(falseNumber == 1){
                    if(params.selected['新增实名认证用户量']) formatter = '{b1}<br />{a1}: {c1}' +this.realNameTag
                    if(params.selected['访问量']) formatter = '{b1}<br />{a1}: {c1}' +this.accessTag
                } 
                if(falseNumber == 2) formatter = '{b}'
                option.tooltip.formatter = formatter
                echart2.setOption(option)
                
            
            });
            
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftcenter.png');
    background-size: 100% 100%;
    margin-bottom:10px;
    margin-top:10px;
    height:100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}
</style>